import React from 'react';
import { Select, Button, Input } from "antd";

const { Option } = Select;

interface TicketFiltersProps {
    categories: { key: number; Category: string }[];
    selectedCategory: number | null;
    setSelectedCategory: (value: number | null) => void;
    selectedPriority: number | null;
    setSelectedPriority: (value: number | null) => void;
    selectedOperationStatus: number | null;
    setSelectedOperationStatus: (value: number | null) => void;
    searchTerm: string;
    setSearchTerm: (value: string) => void;
    onClearFilters: () => void;
    showClearButton: boolean;
}

const TicketFilters: React.FC<TicketFiltersProps> = ({
    categories,
    selectedCategory,
    setSelectedCategory,
    selectedPriority,
    setSelectedPriority,
    selectedOperationStatus,
    setSelectedOperationStatus,
    searchTerm,
    setSearchTerm,
    onClearFilters,
    showClearButton
}) => {
    return (
        <div className="d-flex gap-2 flex-wrap">
            <Input
                placeholder="Search tickets..."
                value={searchTerm}
                onChange={(e: any) => setSearchTerm(e.target.value)}
                style={{ width: 200 }}
                allowClear
            />
            <Select
                placeholder="Category"
                value={selectedCategory}
                onChange={setSelectedCategory}
                style={{ width: 150 }}
                allowClear
            >
                <Option value={null}>All Categories</Option>
                {categories.map((cat) => (
                    <Option key={cat.key} value={cat.key}>
                        {cat.Category}
                    </Option>
                ))}
            </Select>
            <Select
                placeholder="Priority"
                value={selectedPriority}
                onChange={setSelectedPriority}
                style={{ width: 130 }}
                allowClear
            >
                <Option value={null}>All Priorities</Option>
                <Option value={0}>Low</Option>
                <Option value={1}>Medium</Option>
                <Option value={2}>High</Option>
            </Select>
            <Select
                placeholder="Status"
                value={selectedOperationStatus}
                onChange={setSelectedOperationStatus}
                style={{ width: 130 }}
                allowClear
            >
                <Option value={null}>All Statuses</Option>
                <Option value={1}>New</Option>
                <Option value={2}>Open</Option>
                <Option value={3}>Pending</Option>
                <Option value={4}>Closed</Option>
            </Select>
            {showClearButton && (
                <Button onClick={onClearFilters}>Clear Filters</Button>
            )}
        </div>
    );
};

export default TicketFilters;